
const teamNameShort = (team_index) => {
    const teams = ['Groep A', 'Groep B', 'Groep C'];
    if (typeof (team_index) !== 'number' || team_index < 0 || team_index >= teams.length) {
        return 'Onbekend';
    }
    return teams[team_index];
};

const teamName = (team_index) => {
    if (typeof (team_index) !== 'number') {
        return 'Onbekend';
    }
    return 'Verantwoordelijke ' + teamNameShort(team_index);
};

const meterNames = [
    "Kracht en tegenkracht",
    "Moreel kompas",
    "Bewonersbelang",
    "Volkshuisvestelijke continuïteit",
    "Risicobereidheid",
];
const meterNamesAbbr = [
    "Kracht",
    "Mor.K.",
    "Bew.",
    "Volk.",
    "Risc.",
];

export default {
    teamName: teamName,
    teamNameShort: teamNameShort,
    meterNames: meterNames,
    meterNamesAbbr: meterNamesAbbr,
    useTeams: false
}